import React, { useEffect, useState, useRef } from "react";
import Dashboard from "../../layouts/Dashboard";
import axios from "../../services/axios";
import { message } from "antd";
import ReactLoading from "react-loading";
import { DatePicker, Input, Select } from "antd";
import TodayCandidateList from "./TodayCandidateList";
import PendingCandidateList from "./PendingCandidateList";
import CompletedCandidateList from "./CompletedCandidateList";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { Tooltip } from "antd";
import exportFromJSON from "export-from-json";
import moment from "moment";
import useAxios from "../../hooks/useAxios";
import swal from "sweetalert";
import useDocSearchContext from "../../hooks/useDocSearchContext";

const { Search } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;

const CandidateList = (props) => {
  const [candidateList, setCandidateList] = useState([]);
  const [count, setCount] = useState("");
  const [current, setCurrent] = useState(1);
  const [load, setLoad] = useState(false);
  const abortController = new AbortController();
  const { signal } = abortController;
  const [businessTypeList, setBusinessTypeList] = useState([]);
  const [locations, setLocations] = useState([]);
  const [formNames, setFormNames] = useState([]);
  const {
    formId,
    setFormId,
    businessType,
    setBusinessType,
    search,
    setSearch,
    location,
    setLocation,
    onboardStatus,
    setOnboardStatus,
    filter,
    setFilter,
  } = useDocSearchContext();
  const api = useAxios();

  const getBusinessTypeList = async () => {
    try {
      const response = await api.get(`/samparkDomain`, { tokenType: "user" });
      setBusinessTypeList(response.data.samparkDomainList);
    } catch (err) {
      console.log(err);
    }
  };

  const getLocations = async () => {
    try {
      const res = await api.get("/location", { tokenType: "user" });
      setLocations(res.data.locationMaster);
    } catch (err) {
      console.log(err);
    }
  };

  const getFormNames = async () => {
    try {
      const res = await api.get("/formtemplate", { tokenType: "user" });
      setFormNames(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    Promise.all([getBusinessTypeList(), getLocations(), getFormNames()]);
  }, []);

  useEffect(() => {
    loadCandidates();
    return () => abortController.abort();
  }, [current, businessType, onboardStatus, location, formId]);

  const initialRender = useRef(false);

  useEffect(() => {
    if (!initialRender.current) {
      initialRender.current = true;
      return;
    }
    const timeOut = setTimeout(async () => {
      loadCandidates(1);
    }, 500);

    return () => clearTimeout(timeOut);
  }, [search]);

  const pagenNo = (pagenNo) => {
    setCurrent(pagenNo);
  };

  const loadCandidates = (page = 0) => {
    setLoad(true);
    axios
      // .get(
      //   `candidateDocuments/AllCandidateList?PageNo=${
      //     page ? page : current
      //   }&PageSize=10&Search=${str.trim()}&Status=${advanceFilter ? onboardStatus : ""}&BusinessType=${advanceFilter ? businessType : ""}&StartDate=${advanceFilter ? defaultDate[0] ? defaultDate[0] : "": ""}&EndDate=${advanceFilter ? defaultDate[1] ? defaultDate[1] : "" : ""}`,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      //     },
      //     signal,
      //   }
      // )
      .get(
        `candidateDocuments/AllCandidateList?PageNo=${
          page ? page : current
        }&PageSize=10&Search=${search.trim()}&status=${onboardStatus}&formId=${formId}&location=${location}&businessType=${businessType}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
          signal,
        }
      )
      .then((res) => {
        setCandidateList(res.data.candidateDocumentDetails);
        setCount(res.data.candidateDocumentDetailsCount);
        setLoad(false);
      })
      .catch((err) => {
        console.log(err);
        setLoad(false);
      });
  };

  const clearFilters = () => {
    setSearch("");
    setBusinessType("");
    setOnboardStatus("");
    setFormId("");
    setLocation("");
  };

  return (
    <Dashboard title="Documents">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="row py-3 border bg-white mb-2 align-items-center">
        <div className="col-md-3">
          <Search
            placeholder="Name | Email | Phone | Emp Id"
            value={search}
            onChange={(e) => {
              setFilter({
                ...filter,
                Search: e.target.value,
              });
              setSearch(e.target.value);
            }}
            style={{
              width: "100%",
              height: "32px",
            }}
          />
        </div>
        <div className="col-md-2">
          <Select
            id="busineesType"
            showSearch
            value={businessType || null}
            style={{ width: "100%", height: "32px" }}
            placeholder="Select Business"
            optionFilterProp="children"
            filterOption={(input, option) => {
              return (
                option?.children?.toLowerCase().indexOf(input.toLowerCase()) >=
                  0 ||
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
            onChange={(value) => {
              setCurrent(1);
              setFilter({
                ...filter,
                Business: value,
              });
              setBusinessType(value);
            }}
          >
            <Option style={{ background: "#80808047" }} value={""}>
              Select Business
            </Option>
            {businessTypeList?.map((business) => (
              <Option value={business?.businessType}>
                {business?.businessType}
              </Option>
            ))}
          </Select>
        </div>
        <div className="col-md-2">
          <Select
            showSearch
            style={{ width: "100%", height: "32px" }}
            placeholder="Select Location"
            maxTagCount={1}
            value={location || null}
            optionFilterProp="children"
            filterOption={(input, option) => {
              return (
                option?.children?.toLowerCase().indexOf(input.toLowerCase()) >=
                  0 ||
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
            onChange={(value) => {
              setCurrent(1);
              setLocation(value);
              setFilter({
                ...filter,
                Location: value,
              });
            }}
          >
            <Option style={{ background: "#80808047" }} value={""}>
              Select Location
            </Option>
            {locations
              ?.sort((a, b) =>
                a.locationName
                  ?.trim()
                  .toLowerCase()
                  .localeCompare(b.locationName?.trim().toLowerCase())
              )
              ?.map((loc) => {
                if (!loc.status) return;
                return (
                  <Option key={loc?._id} value={loc?.locationName?.trim()}>
                    {loc?.locationName?.trim()}
                  </Option>
                );
              })}
          </Select>
        </div>
        <div className="col-md-2">
          <Select
            showSearch
            style={{ width: "100%", height: "32px" }}
            value={formId || null}
            placeholder="Application Type"
            optionFilterProp="children"
            filterOption={(input, option) => {
              return (
                option?.children?.toLowerCase().indexOf(input.toLowerCase()) >=
                  0 ||
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
            onChange={(value) => {
              setCurrent(1);
              setFormId(value);
              setFilter({
                ...filter,
                Application: value,
              });
            }}
          >
            <Option style={{ background: "#80808047" }} value={""}>
              Select Application
            </Option>
            {formNames
              ?.sort((a, b) =>
                a.name
                  ?.trim()
                  .toLowerCase()
                  .localeCompare(b.name?.trim().toLowerCase())
              )
              ?.map((form) => {
                if (form.formType === "Document_Form") return;
                return (
                  <Option key={form?._id} value={form?._id}>
                    {form?.name?.trim()}
                  </Option>
                );
              })}
          </Select>
        </div>
        <div className="col-md-2">
          <Select
            id="onboard"
            showSearch
            value={onboardStatus || null}
            style={{ width: "100%", height: "32px" }}
            placeholder="Select Onboard Status"
            optionFilterProp="children"
            filterOption={(input, option) => {
              return (
                option?.children?.toLowerCase().indexOf(input.toLowerCase()) >=
                  0 ||
                option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
            onChange={(value) => {
              setCurrent(1);
              setOnboardStatus(value);
              setFilter({
                ...filter,
                Status: value,
              });
            }}
          >
            <Option style={{ background: "#80808047" }} value={""}>
              Select Status
            </Option>
            <Option value={"false"}>Pending</Option>
            <Option value={"true"}>Onboarded</Option>
          </Select>
        </div>
        <div className="col-md-1 p-0" onClick={clearFilters}>
          <button className="bg-white filter-group filter-group-btn">
            <i
              className="custom-black-text fa fa-rotate-left"
              aria-hidden="true"
            ></i>
          </button>
        </div>
      </div>
      {/* <Tabs>
        <Tabs.TabPane tab="Today " key="item-1">
          <TodayCandidateList candidateList={candidateList} count={count}/>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Pending" key="item-2">
          <PendingCandidateList candidateList={candidateList} count={count}/>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Completed" key="item-3">
          <CompletedCandidateList candidateList={candidateList} count={count}/>
        </Tabs.TabPane>
      </Tabs> */}
      <TodayCandidateList
        candidateList={candidateList}
        count={count}
        pagenNo={pagenNo}
        filter={filter}
      />
    </Dashboard>
  );
};

export default CandidateList;
